module.exports = __webpack_public_path__ + "static/media/cock-wearing-chasma.44baef1e.gif";